import type { StyleLayer } from './utils/types'

export const layers_radinfra_width: StyleLayer[] = [
  {
    id: 'width-missing',
    type: 'line',
    filter: ['any', ['!', ['has', 'width']], ['match', ['get', 'width'], [''], true, false]],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': '#fda5e4',
      'line-dasharray': [3, 1],
      'line-offset': ['interpolate', ['linear'], ['zoom'], 12, 0, 15, -1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 12, 1, 22, 4],
    },
  },
  {
    id: 'hitarea-missing-width',
    type: 'line',
    filter: ['any', ['!', ['has', 'width']], ['match', ['get', 'width'], [''], true, false]],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': 'rgb(216, 20, 255)',
      'line-dasharray': [3, 1],
      'line-offset': ['interpolate', ['linear'], ['zoom'], 12, 0, 15, -1],
      'line-opacity': 0,
      'line-width': ['interpolate', ['linear'], ['zoom'], 9, 1, 14.1, 10, 22, 12],
    },
  },
  {
    id: 'width-colors',
    type: 'line',
    filter: ['has', 'width'],
    paint: {
      'line-color': [
        'interpolate',
        ['linear'],
        ['get', 'width'],
        0.5,
        '#ef9043',
        1.1,
        '#f6de09',
        1.6,
        '#a1e217',
        2.2,
        '#15c65c',
      ],
      'line-offset': ['interpolate', ['linear'], ['zoom'], 12, 0, 15, -1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1.5, 16, 4],
    },
  },
]
